import { create } from 'zustand';

interface StoreState {
  isMobile: boolean;
  setIsMobile: (value: boolean) => void;
}

const useGeneralStore = create<StoreState>((set) => ({
  isMobile: typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  setIsMobile: (value: boolean) => set({ isMobile: value }),
}));

export default useGeneralStore;
